import { LoggedInUserDto } from 'src/generated/services/TFinancialApi';

/**
 * A simple store to hold user details outside of React context
 * This allows non-React code (like interceptors) to access user data
 */
class UserStore {
  private userDetails: LoggedInUserDto | null = null;

  private listeners: Array<() => void> = [];

  /**
   * Update the user details in the store
   */
  setUserDetails(userDetails: LoggedInUserDto | null): void {
    this.userDetails = userDetails;
    this.notifyListeners();
  }

  /**
   * Get the current user details
   */
  getUserDetails(): LoggedInUserDto | null {
    return this.userDetails;
  }

  /**
   * Get the default billed entity ID if available
   */
  getDefaultBilledEntityId(): string | null {
    if (this.userDetails?.billedEntity?.id) {
      return this.userDetails.billedEntity.id.toString();
    }
    return null;
  }

  /**
   * Subscribe to changes in user details
   */
  subscribe(listener: () => void): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  /**
   * Notify all listeners of changes
   */
  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener());
  }
}

// Create a singleton instance
export const userStore = new UserStore();
